import React from 'react';
import { config } from '../../config';
import { __ } from '../../helpers/TranslationService';
import styled from '@emotion/styled';

const StyledLoaderContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.8);
    z-index: ${(props) => props.theme.overlayIndexes.requestFormLoader};
`;

const StyledLoaderText = styled.span`
    font-size: 20px;
    font-weight: bold;
    color: ${(props) => props.theme.colors.peacockBlue[100]};
    padding-left: 10px;
`;

export const RequestFormLoader = (props: { className?: string }) => {
    return (
        <StyledLoaderContainer {...props}>
            <img alt="Loading" src={`${config.images}/common/loading.gif`} width={80} height={80} />
            <StyledLoaderText>{__('buttons.pleaseWait', 'dreamlines')}</StyledLoaderText>
        </StyledLoaderContainer>
    );
};
